import radioDefault from '../image/radio-pink.svg';
import radioYellow from '../image/radio-yellow.svg';
import radioBlue from '../image/radio-blue.svg';
import radioGreen from '../image/radio-green.svg';

export const themes = {
  pink: {
    mainColor: '#F9C2BA',
    subColor01: '#FFD7D0',
    subColor02: '#F6A6A1',
    subColor03: '#E68A8D',
    radio: radioDefault
  },
  green: {
    mainColor: '#C2E8D5',
    subColor01: '#d5f0e6',
    subColor02: '#A8D9C4',
    subColor03: '#82C9AB',
    radio: radioGreen
  },
  blue: {
    mainColor: '#D4E5F9',
    subColor01: '#e2f1fd',
    subColor02: '#AFCDEA',
    subColor03: '#91BCE0',
    radio: radioBlue
  },
  yellow: {
    mainColor: '#FFF3CC',
    subColor01: '#fff5d7',
    subColor02: '#FFEB99',
    subColor03: '#FFD966',
    radio: radioYellow
  }
};
